<template>
  <router-view v-slot="{ Component, route }">
    <transition :name="transitionName" mode="out-in">
      <!-- As páginas têm vários elementos raiz, então o wrapper permite animar a troca -->
      <div :key="route.path" class="page-wrapper">
        <component :is="Component" />
      </div>
    </transition>
  </router-view>
  <Analytics />
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { Analytics } from '@vercel/analytics/vue'

// Fade apenas ao entrar ou sair da página de CV
const fadeRoutes = ['/cv']
const transitionName = ref('')

useRouter().beforeEach((to, from) => {
  const isFadeRoute = fadeRoutes.includes(to.path) || fadeRoutes.includes(from.path)
  transitionName.value = isFadeRoute ? 'page-fade' : 'page-none'
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
/*  height: 100%;*/
  margin: 0;
}
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.45s ease;
}

.page-fade-enter-from,
.page-fade-leave-to {
  opacity: 0;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
/*  height: 100%;*/
}
</style>
